import { Component, OnInit, ViewChild } from '@angular/core';
import { IonSlides } from '@ionic/angular';
import { ApiService, APIData } from '../../services/api.service';
import { ModalComponent } from '../modal/modal.component';
import { ModalController } from '@ionic/angular';
import { FuncService } from '../../services/func.service';

@Component({
  selector: 'app-calculator',
  templateUrl: './calculator.component.html',
  styleUrls: ['./calculator.component.scss'],
})
export class CalculatorComponent implements OnInit {

  @ViewChild('slider') slides: IonSlides;

  apiData: APIData;
  disablePrevBtn = true;
  disableNextBtn = false;

  formData = {
    bur: '',
    licencePeriod: 0,
    mediaUsages: [],
    territoryUsages: [],
  };

  mediaCategories = [];
  territoryCategories = [];

  maxMediaUsage = null;
  maxTerritoryUsage = null;

  filterMediaTerm: string;
  filterTerritoryTerm: string;

  burDescriptionVisible = false;

  slideOpts = {
    allowTouchMove: false,
    initialSlide: 0,
  };

  constructor(
    private apiService: ApiService,
    public modalController: ModalController,
    public funcService: FuncService
  ) {}

  ngOnInit() {
    this.fetchData();
  }

  ionViewWillEnter(){
    this.slides.slideTo(0, 0);
  }

  async openModal(message) {
    const modal = await this.modalController.create({
      component: ModalComponent,
      componentProps: {
        'modalData': message
      },
      cssClass: 'custom-modal'
    });
    
    return await modal.present();
  }

  disableMediaOptions(media) {
    for (let item of this.apiData.mediaUsages) {
        var disableOption = (media.selected) ? true : false;

        switch(media.title) {
            case 'All Media':
                if(item.type != 'All') {
                    item.selected = false;
                    item.disabled = disableOption;
                }
                break;
            case 'All Print media':
                if(item.type === 'Print' && item.title !== 'All Print media') {
                    item.selected = false;
                    item.disabled = disableOption;
                }
                break;
            case 'All Digital media':
                if(item.type === 'Digital' && item.title !== 'All Digital media') {
                    item.selected = false;
                    item.disabled = disableOption;
                }
                break;
        }
    }
  }

  disableTerritoryOptions(territory) {
    for (let item of this.apiData.territoryUsages) {
      var disableOption = (territory.selected) ? true : false;
      switch(territory.title) {
          case 'Worldwide':
              if(item.title != 'Worldwide') {
                  item.selected = false;
                  item.disabled = disableOption;
              }
              break;
      }
    }
  }

  toggleBurDescriptionVisibility() {
    this.burDescriptionVisible = !this.burDescriptionVisible;
  }

  toggleMediaType(media) {
    if(media.disabled) {
        return;
    }
    media.selected = !media.selected;

    this.disableMediaOptions(media);
  }

  toggleTerritoryType(territory) {
    if(territory.disabled) {
      return;
    }
    territory.selected = !territory.selected;

    this.disableTerritoryOptions(territory);
  }

  fetchData() {
    this.apiService.fetch().subscribe((data)=> {
      this.apiData = data;

      this.maxMediaUsage = this.apiData.mediaUsages.reduce((max, usage) => max.value > usage.value ? max : usage);
      this.maxTerritoryUsage = this.apiData.territoryUsages.reduce((max, usage) => max.value > usage.value ? max : usage);

      let mc = this.apiData.mediaCategories;
      for(let i=0; i<mc.length; i++) {
        this.mediaCategories[i] = {
          name: mc[i],
          show: true
        }
      }

      this.mediaCategories.sort((a,b) => a.name.localeCompare(b.name));

      let tc = this.apiData.territoryCategories;
      for(let i=0; i<tc.length; i++) {
        this.territoryCategories[i] = {
          name: tc[i],
          show: true
        }
      }

    }, (err)=> {
      console.log(err);
    });
  }

  nextSlide() {
    let proceed = true;

    this.slides.getActiveIndex().then((slideIndex) => {
      if(slideIndex == 2) {
        let selectedMediaUsages = this.apiData.mediaUsages.filter((mediaType) => mediaType.selected);
        if(selectedMediaUsages.length) {
          let totalMediaValue = (selectedMediaUsages.map(o=>o.value).reduce((a,c)=>a+c));
          if(totalMediaValue > this.maxMediaUsage.value) {
            for (let item of this.apiData.mediaUsages) {
              if(item.id === this.maxMediaUsage.id) {
                item.selected = true;
              } else {
                item.selected = false;
                item.disabled = true;
              }
            }
    
            let message = {
              title: 'Media Usage Change',
              description: `
                We have optimised your usage option to provide the most cost effective results 
                for your selection. We always do this when the total % exceeds 'All Media'.
              `
            }
            this.openModal(message);
          }
        }
      }

      if(slideIndex == 3) {
        let selectedTerritoryUsages = this.apiData.territoryUsages.filter((territory) => territory.selected);

        if(selectedTerritoryUsages.length) {
          // Check if overlapping territories
          let overlappingTerritories = [];
          for(let item of selectedTerritoryUsages) {
            let countries = item.countries;
            for(let compareItem of selectedTerritoryUsages) {
              if(item.id != compareItem.id) {
                let compareCountries = compareItem.countries;
    
                if(countries != null && compareCountries != null) {
                  let isFound = countries.some(a => compareCountries.includes(a));
                  if(isFound) {
                    overlappingTerritories.push(item.title);
                    overlappingTerritories.push(compareItem.title);
                  }
                }
              }
            }
          }
    
          if(!overlappingTerritories.length) {
            let totalTerritoryValue = (selectedTerritoryUsages.map(o=>o.value).reduce((a,c)=>a+c));
            if(totalTerritoryValue > this.maxTerritoryUsage.value) {
              for (let item of this.apiData.territoryUsages) {
                if(item.id === this.maxTerritoryUsage.id) {
                  item.selected = true;
                } else {
                  item.selected = false;
                  item.disabled = true;
                }
              }
    
              let message = {
                title: 'Territory Usage Change',
                description: `
                  We have optimised your usage option to provide the most cost effective results 
                  for your selection. We always do this when the total % exceeds 'Worldwide'.
                `
              }
              this.openModal(message);
            }
          } else {
            proceed = false;
            let uniqueTerritories = [...new Set(overlappingTerritories)]
            let message = {
              title: 'Territory Usage Overlap',
              description: `
                Please note that the territories listed below appear to be overlapping. You should 
                reselect your territories to ensure there is no overlap before proceeding.<br><br> ${uniqueTerritories.join('<br>')}
              `
            }
            this.openModal(message);
          }
        }
      }
    }).then(() => {
      if(proceed) {
        this.slides.slideNext();
      }
    });
  }

  prevSlide() {
    this.slides.slidePrev();
  }

  isTypeShown(type) {
    return type.show;
  }

  toggleType(type) {
    type.show = !type.show;
  }

  doCheck() {
    let prom1 = this.slides.isBeginning();
    let prom2 = this.slides.isEnd();
  
    Promise.all([prom1, prom2]).then((data) => {
      data[0] ? this.disablePrevBtn = true : this.disablePrevBtn = false;
      data[1] ? this.disableNextBtn = true : this.disableNextBtn = false;
    });
  }
}
